import { useContext, useState } from "react";

import { Button } from "@/components/common/Button";
import { useDepartmentRoute } from "@/hooks/common/use-department-route";
import { useUserStore } from "@/stores/use-user-store";
import { canManageScheduleStage } from "@/utils/features/schedule/permission";
import { getUserRoleByDepartment, isProducerUnavailableInDepartment } from "@/utils/user-positions";

import { MoveScheduleStageModal } from "../../modals/MoveScheduleStageModal";
import { ScheduleActionsContext } from "../Provider";

export const ScheduleActionsMoveStage = () => {
  const [isOpen, setIsOpen] = useState(false);
  const { department } = useDepartmentRoute();
  const activeUser = useUserStore((state) => state.activeUser);
  const activeRole = getUserRoleByDepartment(activeUser, department);
  const { schedule } = useContext(ScheduleActionsContext);
  const canManageStage = canManageScheduleStage(activeRole, schedule);

  if (isProducerUnavailableInDepartment(activeUser, department) || !canManageStage) {
    return null;
  }

  return (
    <>
      <Button className="max-w-none" variant={"secondary"} leading={"ArrowRight"} onClick={() => setIsOpen(true)}>
        Mover etapa
      </Button>
      <MoveScheduleStageModal isOpen={isOpen} schedule={schedule} onClose={() => setIsOpen(false)} />
    </>
  );
};
